import NextImage from "../../lib/NextImage";
import BaseOption from "./base-checkbox/BaseOption";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  image_src: string;
  disabled?: boolean;
  is_multi_select: boolean;
  label: string;
  isProductBox?: boolean;
  outOfStock?: boolean;
}

const ImageOption: React.FC<Props> = ({
  selected,
  toggleOption,
  image_src,
  label,
  disabled = false,
  is_multi_select,
  isProductBox,
  outOfStock,
}) => {
  return (
    <div
      onClick={disabled ? () => {} : toggleOption}
      className={`product-add-on ${selected ? "checked" : ""} ${
        outOfStock ? "disabled" : ""
      }`}
      style={
        isProductBox
          ? {
              width: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 1,
              border: "1px solid",
              borderColor: !selected ? "#FFFF" : undefined,
              borderRadius: 10,
            }
          : undefined
      }
    >
      <div
        className="add-on-image"
        style={
          isProductBox
            ? { width: 16, height: 16, borderRadius: 10, position: "relative" }
            : { position: "relative" }
        }
      >
        <NextImage alt="" src={image_src} objectFit="fill" />
        {outOfStock && (
          <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              pointerEvents: "none",
            }}
          >
            <line
              x1="100"
              y1="0"
              x2="0"
              y2="100"
              stroke="#e2e2e2"
              strokeWidth="1"
              strokeLinecap="round"
            />
          </svg>
        )}
      </div>
      {!isProductBox && (
        <BaseOption
          disabled={disabled}
          selected={selected}
          toggleOption={toggleOption}
          is_multi_select={is_multi_select}
          label={label}
          alloweSelectOutOfStock={outOfStock}
        />
      )}
    </div>
  );
};

export default ImageOption;
